export default __webpack_public_path__ + "static/data-leakage-431a233f445653384478dcf8da47ec41.png";